import React from 'react';
import AuthService from './AuthService';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

//-------------------------------------------------------------------------------------
let XAuthContext = React.createContext(null);
let NavigationContext = React.createContext(null);

export function AuthProvider({ children }) {
    const auth = new AuthService();
    return <XAuthContext.Provider value={auth}>{children}</XAuthContext.Provider>;
}
export function useAuth() {
    return React.useContext(XAuthContext);
}
export function useNavigation() {
    return React.useContext(NavigationContext);
}
export function RequireAuth({ children }) {
    let auth = useAuth();
    let location = useLocation();
    let navigate = useNavigate();

    if (!auth.loggedIn()) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/app/login" state={{ from: location }} />;
    } 
    return <NavigationContext.Provider value={navigate}>{children}</NavigationContext.Provider>;
}
//-------------------------------------------------------------------------------------